<template>
  <UpgradePlan
    class="pt-2"
    text="You can add more repositories on the next plan."
    :limit-text
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useUserSubscriptionsStore } from '@/store/user/subscriptions'

import UpgradePlan from '@/modules/UpgradePlan/UpgradePlan.vue'

type Emits = {
  click: []
}

const emit = defineEmits<Emits>()

const userSubscriptionsStore = useUserSubscriptionsStore()

const maxRepos = computed(() => userSubscriptionsStore.getMaxReposNumber)

const limitText = computed(() => {
  return `You have reached the maximum number of ${maxRepos.value} repositories.`
})

const handleClick = () => {
  emit('click')
}
</script>
